import React, { useEffect, useState } from "react";

import apiClient from "../../../services/apiClient";
import { openMonthlySummary } from "./monthlySummaryOpen";

// 학원관리 탭에 두는 월간 결산 입구.
//
// 결산 자체는 서버가 만든 HTML 한 장이라 새 탭으로 연다. 교사 화면에 같은 내용을
// 다시 그리면 두 벌이 되어 한쪽만 고쳐진다.
const MonthlySummaryCard = ({ isMobile }) => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    apiClient
      .get("/api/v1/echo/monthly-summary/mine", { withAuth: true })
      .then((response) => setSummary(response.data))
      .catch(() => setSummary(null));
  }, []);

  if (!summary || !summary.ready) return null;

  return (
    <div
      style={{
        border: "1px solid #E3EBEA",
        borderTop: "3px solid #00A396",
        background: "#FAFCFC",
        padding: isMobile ? "16px 16px" : "20px 22px",
        marginBottom: "22px",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "stretch" : "center",
        justifyContent: "space-between",
        gap: "12px",
      }}
    >
      <div>
        <div style={{ fontSize: "17px", fontWeight: 800, marginBottom: "4px" }}>
          {summary.month_label} 학습 진단 보고서가 나왔습니다
        </div>
        <div style={{ fontSize: "14px", color: "#5b666f", lineHeight: 1.6 }}>
          다른 학원과 견준 결과, 아이별 현황, 다음 달에 바꿀 것을 정리했습니다.
        </div>
      </div>
      <button
        type="button"
        onClick={() =>
          openMonthlySummary({
            month: summary.month,
            title: `${summary.month_label} 학습 진단`,
          })
        }
        style={{
          border: "none",
          cursor: "pointer",
          background: "#0E141B",
          color: "#fff",
          fontWeight: 800,
          fontSize: "14px",
          padding: "11px 20px",
          textDecoration: "none",
          textAlign: "center",
          whiteSpace: "nowrap",
        }}
      >
        결산 보기
      </button>
    </div>
  );
};

export default MonthlySummaryCard;
